import React from 'react'
import {Col} from 'reactstrap'

import Error from './elements/Error'
import CheckBox from '../elements/CheckBox'

function CheckVal(props) {

    const {name, data, field, info, disabled, error} = props;
    let value = data && data[field];

    const onChange = (e) => {
        value = !value;
        props.onChange(data, field, +value);
    };

    return (
        <div className="form-group row g-0">
            <Col sm="12">
                <CheckBox checked={value} label={name} info={info} onChange={onChange} disabled={disabled} />
                <div className="mt-2 ms-3">
                    {error &&
                    <Error id={field} error={error}/>}
                </div>
            </Col>
        </div>);
}

export default CheckVal;